module.exports = __webpack_public_path__ + "media/images/athletes/1615-661d6494f0c96565be0ea573bc1a07be.png";